/**
 * Earliest ISO date (`yyyy-MM-dd`) among optional bounds — for native `<input type="date" max>`.
 * Lexicographic sort works for that format.
 */
export function resolveDateInputMax(options: {
  rangeBound?: string | number | null;
  maxValue?: string | number | null;
  disableFuture?: boolean;
  /** Overrideable for tests; defaults to local today. */
  today?: string;
}): string | undefined {
  const candidates: string[] = [];

  if (options.rangeBound != null && options.rangeBound !== '') {
    candidates.push(String(options.rangeBound));
  }
  if (options.maxValue != null && options.maxValue !== '') {
    candidates.push(String(options.maxValue));
  }
  if (options.disableFuture) {
    candidates.push(options.today ?? formatLocalToday());
  }

  if (candidates.length === 0) return undefined;
  return [...candidates].sort()[0];
}

function formatLocalToday(): string {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}
